import {WarriorClass} from "@/store/level/types";

export interface CreatureState {
}

export class LevelsInfo {
    warriorClass!: WarriorClass;
    level!: number;
    doneCount!: number;
    requiredCount!: number;
    speedupPrice!: number;
    speedupTill!: number;
    completePrice!: number;
    levels!: LevelInfo[];

    nsRequired?: number;
    arkRequired?: number;
    onUnavailableText?: string;
}

export class LevelInfo {
    level!: number;
    description!: string;
    requiredBestVictory!: number;
}
